import { PartyPopper, AlertTriangle, Sparkles, Coins, Package, X } from "lucide-react";

const TONE = {
  good: { icon: PartyPopper, ring: "border-green-300", chip: "bg-green-100 text-green-700", head: "text-green-700", label: "Good news!" },
  bad: { icon: AlertTriangle, ring: "border-red-300", chip: "bg-red-100 text-red-700", head: "text-red-700", label: "Uh oh…" },
  neutral: { icon: Sparkles, ring: "border-secondary/40", chip: "bg-secondary/15 text-secondary", head: "text-secondary", label: "Something happened" },
};

export const EventPopup = ({ event, onClose }) => {
  if (!event) return null;
  const t = TONE[event.tone] || TONE.neutral;
  const Icon = t.icon;
  const statEntries = Object.entries(event.eff || {});
  return (
    <div className="fixed inset-0 z-[90] flex items-end justify-center bg-black/50 p-4 sm:items-center" data-testid="event-popup" onClick={onClose}>
      <div className={`w-full max-w-sm rounded-2xl border-2 bg-card p-5 shadow-2xl ${t.ring}`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-start justify-between">
          <div className="flex items-center gap-2">
            <span className={`grid h-10 w-10 place-items-center rounded-full ${t.chip}`}><Icon size={20} /></span>
            <p className={`font-display text-lg font-bold ${t.head}`} data-testid="event-title">{t.label}</p>
          </div>
          <button data-testid="event-close" onClick={onClose} className="rounded-full p-1 text-muted-foreground hover:bg-muted"><X size={18} /></button>
        </div>

        <p className="mt-3 text-sm text-foreground/90" data-testid="event-text">{event.text}</p>

        {(statEntries.length > 0 || event.currency || (event.items && event.items.length > 0)) && (
          <div className="mt-3 flex flex-wrap gap-1.5" data-testid="event-effects">
            {statEntries.map(([k, v]) => (
              <span key={k} className={`rounded-full px-2 py-0.5 text-[11px] font-bold capitalize ${v >= 0 ? "bg-green-100 text-green-700" : "bg-red-100 text-red-700"}`}>
                {k} {v >= 0 ? "+" : ""}{v}
              </span>
            ))}
            {event.currency ? (
              <span data-testid="event-currency" className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-bold ${event.currency >= 0 ? "bg-amber-100 text-amber-700" : "bg-red-100 text-red-700"}`}>
                <Coins size={11} /> {event.currency >= 0 ? "+" : ""}{event.currency} coins
              </span>
            ) : null}
            {(event.items || []).map((it) => (
              <span key={it.name} className="inline-flex items-center gap-1 rounded-full bg-secondary/15 px-2 py-0.5 text-[11px] font-bold text-secondary">
                <Package size={11} /> {it.name} ×{it.qty}
              </span>
            ))}
          </div>
        )}

        <button data-testid="event-ok-btn" onClick={onClose}
          className="mt-4 h-11 w-full rounded-xl bg-primary font-bold text-primary-foreground active:scale-95">
          Got it
        </button>
      </div>
    </div>
  );
};
